module.exports = __webpack_public_path__ + "static/img/ragor.5965a60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_supporters/ragor.jpg
// module id = g+Sx
// module chunks = 1